import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ArrowRightLeft, ArrowLeft, ListChecks, Wallet } from "lucide-react";
import CommissionLedgerV2Panel from "../components/analytics/CommissionLedgerV2Panel";
import ProcessCommissionsTab from "../components/analytics/ProcessCommissionsTab";
import AdminMenu from "../components/AdminMenu";

export default function PromptLogCommissionLedgerV2() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  // Support ?user_id=<recipient> to arrive from the GuardianTab deep-link
  // ("View commissions") with the ledger pre-filtered to that affiliate.
  const initialUserId = searchParams.get("user_id") || "";
  const initialTab = searchParams.get("tab") === "process" ? "process" : "ledger";
  const [tab, setTab] = useState(initialTab);

  const switchTab = (next) => {
    setTab(next);
    const p = new URLSearchParams(searchParams);
    if (next === "ledger") p.delete("tab"); else p.set("tab", next);
    setSearchParams(p, { replace: true });
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white/80 p-4 sm:p-6" data-testid="commission-ledger-v2-page">
      <header className="max-w-[1400px] mx-auto mb-6 flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <button
            onClick={() => navigate(-1)}
            className="p-2 rounded-lg text-white/40 hover:text-white hover:bg-white/10 transition-colors"
            data-testid="ledger-back-btn"
            title="Back"
          >
            <ArrowLeft className="w-5 h-5" />
          </button>
          <ArrowRightLeft className="w-5 h-5 text-[#C5A55A]" />
          <div>
            <h1 className="text-lg font-semibold text-white">Commission Ledger (V2)</h1>
            <p className="text-[11px] text-white/40">Click any row to inspect · Guardian Case link included</p>
          </div>
        </div>
        <AdminMenu />
      </header>

      <div className="max-w-[1400px] mx-auto space-y-4">
        {/* Tab bar */}
        <div className="flex items-center gap-1 border-b border-white/10" data-testid="commission-tabs">
          <TabButton
            active={tab === "ledger"}
            onClick={() => switchTab("ledger")}
            icon={<ListChecks className="w-4 h-4" />}
            label="Ledger"
            testId="tab-ledger"
          />
          <TabButton
            active={tab === "process"}
            onClick={() => switchTab("process")}
            icon={<Wallet className="w-4 h-4" />}
            label="Process Commissions"
            testId="tab-process"
          />
        </div>

        {tab === "ledger" && <CommissionLedgerV2Panel initialUserId={initialUserId} />}
        {tab === "process" && <ProcessCommissionsTab />}
      </div>
    </div>
  );
}

function TabButton({ active, onClick, icon, label, testId }) {
  return (
    <button
      onClick={onClick}
      data-testid={testId}
      className={`inline-flex items-center gap-2 px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors ${
        active
          ? "border-[#C5A55A] text-[#C5A55A]"
          : "border-transparent text-white/50 hover:text-white/80"
      }`}
    >
      {icon}
      {label}
    </button>
  );
}
